import React from 'react'
import { FormControl, InputLabel, Select, MenuItem, Tooltip, IconButton } from '@mui/material'
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material'
import { common as commonColors } from '@mui/material/colors'

export default function StackSelector(props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }} className='map-stacks'>
      <FormControl sx={{ mt: 1 }}>
        <InputLabel sx={{ color: commonColors.white }}>Stack</InputLabel>
        <Select
          value={props.activeStack}
          onChange={(e) => props.setActiveStackInternal(e.target.value)}
          label="Stack"
          sx={{
            color: commonColors.white
          }}
        >
          {props.slideMetadata.zstacks.map((zstack, index) => (    
            <MenuItem value={index} key={index}>
              {zstack}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Tooltip title={"Go to stack " + (props.slideMetadata.zstacks[props.activeStack-1]) + " (shift + up)"} placement="right">
          <IconButton size="small" onClick={() => props.setActiveStackInternal(props.activeStack-1)} disabled={props.activeStack < 1}>
            <AddIcon color="white"/>
          </IconButton>
        </Tooltip>
        <Tooltip title={"Go to stack " + (props.slideMetadata.zstacks[props.activeStack+1]) + " (shift + down)"} placement="right">
          <IconButton size="small" onClick={() => props.setActiveStackInternal(props.activeStack+1)} disabled={props.activeStack === props.slideMetadata.zstacks.length -1}>
            <RemoveIcon color="white"/>
          </IconButton>
        </Tooltip>
      </div>
    </div>
  )
}